const expertMask = {
	data: function () {
		return {
			featuredExpert: null,
		}
	},
	props: {
		index: {
			type: Number,
			required: true,
		},
		questions: {
			type: Array,
			required: true,
		},
		results: {
			type: Array,
			required: true,
		},
	},
	render: function () {
		const match = this.questions.find(
			(el) => el.id === this.results[this.index]
		)
		const masterId = match.featuredExpertId
		let expertShown = false
		for (let increment = 0; increment < this.index; increment++) {
			const matchOthers = this.questions.find(
				(el) => el.id === this.results[increment]
			)
			if (masterId == matchOthers.featuredExpertId) {
				expertShown = true
			}
		}
		return expertShown ? null : this.$slots.default
	},
}

export default expertMask
